<template>
<div>
  <dl class="info-dl mt-5">
    <dt>ステータス</dt>
    <dd>{{ item.member_status || '&nbsp;' }}</dd>
    <dt>講師番号</dt>
    <dd>{{ item.lecturer_no || '&nbsp;' }}</dd>
    <dt>氏名</dt>
    <dd>{{ item.name || '&nbsp;' }}</dd>
    <dt>ふりがな</dt>
    <dd>{{ item.name_kana || '&nbsp;' }}</dd>
    <dt>協会ホームページ掲載</dt>
    <dd>{{ this.item.published ? '掲載あり' : '掲載なし' }}</dd>
    <dt>講師名（活動名）</dt>
    <dd>{{ item.lecturer_name || '&nbsp;' }}</dd>
    <dt>生年月日（西暦）</dt>
    <dd>{{ item.birthday || '&nbsp;' }}</dd>
    <dt>メールアドレス</dt>
    <dd>{{ item.email || '&nbsp;' }}</dd>
    <dt>住所</dt>
    <dd>{{ fullAddress || '&nbsp;' }}</dd>
    <dt>携帯電話番号</dt>
    <dd>{{ item.tel || '&nbsp;' }}</dd>
    <dt>ホームページURL</dt>
    <dd>{{ item.homepage || '&nbsp;' }}</dd>
    <dt>FACEBOOKページ</dt>
    <dd>{{ item.facebook || '&nbsp;' }}</dd>
    <dt>LINE@</dt>
    <dd>{{ item.line || '&nbsp;' }}</dd>
    <dt>Instagram@</dt>
    <dd>{{ item.instagram || '&nbsp;' }}</dd>
    <dt>ブログ</dt>
    <dd>{{ item.blog || '&nbsp;' }}</dd>
    <dt>自己紹介</dt>
    <dd class="pre-text">{{ item.introduction || '&nbsp;' }}</dd>
    <dt>取得資格</dt>
    <dd>{{ item.qualification || '&nbsp;' }}</dd>
    <dt>始めたきっかけ</dt>
    <dd class="pre-text">{{ item.trigger || '&nbsp;' }}</dd>
    <dt>やってよかったこと</dt>
    <dd class="pre-text">{{ item.good_things || '&nbsp;' }}</dd>
  </dl>
</div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    fullAddress () {
      return [
        '〒' + this.item.zipcode,
        this.item.prefecture,
        this.item.city,
        this.item.address1,
        this.item.address2
      ].join(' ')
    },
    bank () {
      return this.item.bank || {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// LecturerDetail.vue?6d693500